import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card } from "../../components/ui/card";
import { Separator } from "../../components/ui/separator";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "../../components/ui/popover";
import { PopoverClose } from "@radix-ui/react-popover";
import { useRecoilState, useRecoilValue } from "recoil";
import { isUser, theme, userState } from "../../../src/Atom";
import { signOut } from "firebase/auth";
import { auth } from "../../../src/config/Firebase";
import { User, Plus, LogOut, CloudMoon, Sun } from "lucide-react";

function Nav() {
  const navigate = useNavigate();
  const [imgSrc, setImgSrc] = useRecoilState(userState);
  const [isBadge, setIsBadge] = useRecoilState(isUser);
  const { name } = useRecoilValue(userState);
  const [isDark, setIsDark] = useRecoilState(theme);

  const handleSignOut = async () => {
    try {
      await signOut(auth);
      setImgSrc({
        name: "",
        id: "",
        img: "",
      });
      setIsBadge(false);
      navigate("/login");
    } catch (error) {
      console.error("Sign out error:", error);
    }
  };

  const menuItems = [
    {
      label: "Profile",
      icon: <User className="w-4 h-4" />,
      onClick: () => navigate("/profile"),
    },
    {
      label: "Create",
      icon: <Plus className="w-4 h-4" />,
      onClick: () => navigate("/create"),
    },
    {
      label: "Logout",
      icon: <LogOut className="w-4 h-4" />,
      onClick: handleSignOut,
    },
  ];

   useEffect(() => {
    if (isDark) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [isDark]);

  return (
    <div className="border-b border-zinc-800/50 pt-6">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="h-16 flex items-center justify-between">
          {/* Welcome Message */}
          <div className="flex items-center gap-2">
           {
            name ?  <h1 className="text-lg font-medium dark:text-zinc-100 text-gray-800">
              Welcome back, {" "}
              <span className="text-emerald-400">{name}</span>
            </h1> : (
              <h1 className="text-2xl tracking-tighter font-medium dark:text-zinc-100 text-gray-800">
              Vote {" "}
              <span className="text-emerald-400 tracking-tighter ">it</span>
            </h1>
            )
           }
          </div>
          <div className="flex gap-2">
          <button
              onClick={() => setIsDark(!isDark)}
              className="p-2 text-gray-800 dark:text-gray-200 rounded"
            >
            {
              isDark ?  <Sun size={14}/>:<CloudMoon size={14} /> 
            }
          </button>
          {/* User Menu */}
          {isBadge ? (
            <Popover>
              <PopoverTrigger asChild>
                <Card className="w-10 h-10 rounded-full overflow-hidden cursor-pointer hover:ring-2 hover:ring-emerald-500/50 transition-all">
                  <img
                    src={imgSrc.img}
                    alt="Profile"
                    className="w-full h-full object-cover"
                  />
                </Card>
              </PopoverTrigger>
              <PopoverContent className="w-56 p-1 dark:bg-zinc-900 bg-gray-50 border border-black/10   dark:border-zinc-800 shadow-xl">
                {menuItems.map((item, index) => (
                  <React.Fragment key={item.label}>
                    <PopoverClose asChild>
                      <button
                        onClick={item.onClick}
                        className="w-full px-4 py-2.5 flex items-center gap-3 dark:text-zinc-300 hover:bg-gray-200  dark:hover:bg-zinc-800/50 rounded-lg transition-colors"
                      >
                        {item.icon}
                        <span className="text-sm font-medium">{item.label}</span>
                      </button>
                    </PopoverClose>
                    {index < menuItems.length - 1 && (
                      <Separator className="my-1 bg-black/10 dark:bg-zinc-800" />
                    )}
                  </React.Fragment>
                ))}
              </PopoverContent>
            </Popover>
          ) : (
            <p className="flex items-center border dark:bg-zinc-900/95 bg-gray-100 dark:border-zinc-800 dark:shadow-xl shadow-sm transition-all duration-200 dark:hover:bg-zinc-800/95 hover:bg-gray-200 p-2 rounded-lg gap-2 cursor-pointer" onClick={() => navigate('/create')}>  <Plus className="w-4 h-4" /> Create poll </p>
          )}
          </div>

        
        </div>
      </div>
    </div>
  );
}

export default Nav;